import React, { Component, createRef, useState, useRef, useEffect } from "react";
import Axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import { Row, Col, Card, Button, Space, Typography, Table, Input, Modal, Checkbox, Dropdown, Tooltip, InputNumber, Empty, Tag, Popconfirm, Pagination } from "antd";
import _ from "lodash";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

function SecurityProfiles(props) {
  const [securityProfiles, setSecurityProfiles] = useState([]);
  const [webPages, setWebPages] = useState([]);
  const [selectedSecurityProfile, setSelectedSecurityProfile] = useState(null);

  const [modalWidth, setModalWidth] = useState(1600);
  const [modalOpen, setModalOpen] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const GetSecurityProfiles = async () => {
    let response = await props.AxiosRequest("/api/security-profiles/get");
    setSecurityProfiles(
      response.data.security_profiles.map((m) => {
        return { ...m, key: m.id };
      }),
    );
  };
  const GetWebPages = async () => {
    let response = await props.AxiosRequest("/api/web-pages/get");
    setWebPages(
      response.data.web_pages.map((m) => {
        return { ...m, key: m.id };
      }),
    );
  };

  const AddSecurityProfile = async () => {
    if (!selectedSecurityProfile?.name) return props.MakeNotification("warning", "Please fill in all the required fields.");
    await props.AxiosRequest("/api/security-profiles/insert", { ...selectedSecurityProfile });
    GetSecurityProfiles();
    setModalOpen(false);
  };
  const UpdateSecurityProfile = async () => {
    if (!selectedSecurityProfile?.name) return props.MakeNotification("warning", "Please fill in all the required fields.");
    await props.AxiosRequest("/api/security-profiles/update", { ...selectedSecurityProfile });
    GetSecurityProfiles();
    setModalOpen(false);
  };

  const DeleteSecurityProfile = async (id) => {
    await props.AxiosRequest("/api/security-profiles/delete", { id });
    GetSecurityProfiles();
  };
  const OnSelectWebPageChange = async (newSelectedRowKeys) => {
    setSelectedSecurityProfile({
      ...selectedSecurityProfile,
      web_pages: selectedSecurityProfile.web_pages.map((m) => {
        if (newSelectedRowKeys.includes(m.id)) return { ...m, viewable: 1, editable: 1 };
        return { ...m, viewable: 0, editable: 0 };
      }),
    });
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: OnSelectWebPageChange,
  };

  useEffect(() => {
    GetSecurityProfiles();
    GetWebPages();
  }, []);

  useEffect(() => {
    const resize = () => {
      const maxSize = Math.min(1600, window.innerWidth);
      setModalWidth(maxSize);
    };
    window.addEventListener("resize", resize);
  });

  const security_profiles_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "Users In Group",
      dataIndex: "users_list",
      key: "users_list",
      render: (value, object) => <Tooltip title={value}>{_.truncate(value, { separator: ", ", length: 128 })}</Tooltip>,
    },
    {
      title: "Pages & Permissions",
      dataIndex: "web_pages",
      key: "web_pages",
      render: (value, object) => (
        <Tooltip
          title={value
            .filter((f) => f.editable)
            .map((m) => m.name)
            .join(", ")}
        >
          {_.truncate(
            value
              .filter((f) => f.editable)
              .map((m) => m.name)
              .join(", "),
            { separator: ", ", length: 128 },
          )}
        </Tooltip>
      ),
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (value, object) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              let found_security_profile = securityProfiles.find((f) => f.id === value);
              setSelectedRowKeys(found_security_profile.web_pages.filter((f) => f.viewable).map((m) => m.id));
              setSelectedSecurityProfile({
                ...found_security_profile,
                web_pages: found_security_profile.web_pages.map((wp) => {
                  return { ...wp, key: wp.id };
                }),
              });
              setModalOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>

          <Popconfirm
            title="Are you sure?"
            description={"Are you sure you want to delete " + object.name + "?"}
            onConfirm={() => {
              DeleteSecurityProfile(object.id);
            }}
          >
            <Button size="small" danger>
              <FontAwesomeIcon icon={faTrash} className="mr-1" />
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const web_pages_columns = [
    {
      title: "Seq",
      dataIndex: "seq",
      key: "seq",
      sorter: (a, b) => a.seq - b.seq,
      defaultSortOrder: "ascend",
      hidden: true,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Security Profiles</h1>
        </div>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card
              title={<>Security Profiles</>}
              style={{
                width: "100%",
              }}
              extra={
                <Button
                  type="primary"
                  onClick={() => {
                    setSelectedSecurityProfile({
                      web_pages: webPages.map((wp) => {
                        return { ...wp, viewable: 0, editable: 0, key: wp.id };
                      }),
                    });
                    setModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" /> Add A New Security Profile
                </Button>
              }
            >
              <Table columns={security_profiles_columns} dataSource={securityProfiles}></Table>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        title={selectedSecurityProfile?.id ? "Edit Security Profile" : "Add New Security Profile"}
        centered
        width={modalWidth}
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
          setSelectedSecurityProfile({
            web_pages: webPages
              .map((wp) => {
                return { ...wp, viewable: 0, editable: 0, key: wp.id };
              })
              .sort((a, b) => a.seq - b.seq),
          });
        }}
        footer={
          <>
            <Button
              onClick={() => {
                setModalOpen(false);
                setSelectedSecurityProfile({
                  web_pages: webPages.map((wp) => {
                    return { ...wp, viewable: 0, editable: 0, key: wp.id };
                  }),
                });
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={
                selectedSecurityProfile?.id
                  ? () => {
                      UpdateSecurityProfile();
                    }
                  : () => {
                      AddSecurityProfile();
                    }
              }
            >
              {selectedSecurityProfile?.id ? "Save Changes" : "Add Security Profile"}
            </Button>
          </>
        }
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <label className="col-form-label-sm">Security Profile Name *</label>
            <Input
              value={selectedSecurityProfile?.name}
              onChange={(e) => {
                setSelectedSecurityProfile({ ...selectedSecurityProfile, name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <hr />
          </Col>
          <Col span={24} style={{ maxHeight: "55vh", overflow: "scroll", overflowY: "scroll" }}>
            <Table columns={web_pages_columns} dataSource={selectedSecurityProfile?.web_pages} rowSelection={rowSelection} pagination={{ pageSize: 200 }} />
          </Col>
        </Row>
      </Modal>
    </main>
  );
}

export default SecurityProfiles;
